var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"mainPanel"},[(this.selectedVal == 0)?_c('FeedsConfigurationVue'):_vm._e(),(this.selectedVal == 1)?_c('SummaryConfig'):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }